<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Clientes</h1>
    <button class="btn btn-primary" (click)="novoCliente()">Incluir Novo Cliente</button>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por Nome/Razão Social, Nome Fantasia, CPF/CNPJ..." [(ngModel)]="searchTerm" (input)="search()">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Nome/Razão Social</th>
          <th scope="col">Nome Fantasia / Apelido</th>
          <th scope="col">CPF/CNPJ</th>
          <th scope="col">Telefone</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cliente of paginatedClientes">
          <th scope="row">{{ cliente.id }}</th>
          <td>{{ cliente.nomeRazaoSocial }}</td>
          <td>{{ cliente.nomeFantasia }}</td>
          @if (cliente.cpfCnpj.length === 11) {
            <td>{{ cliente.cpfCnpj | mask: '000.000.000-00' }}</td>
          } @else {
            <td>{{ cliente.cpfCnpj | mask: '00.000.000/0000-00' }}</td>
          }
          


          <td>{{ cliente.telefone | mask: '(00) 00000-0000' }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-warning btn-sm me-2" (click)="editarCliente(cliente.id)">Editar</button>
            <button type="button" class="btn btn-info btn-sm" (click)="verVendasCliente(cliente.id)">Vendas</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(1)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages)">Última</a>
      </li>
    </ul>
  </nav>
</div>
